import { BitrixVue } from 'ui.vue';

BitrixVue.component('Checkbox', {
	data() {
		return {
			checked: false,
		};
	},
	props: ['state', 'name', 'title', 'text', 'checkedProp'],
	mounted() {
		if (this.checkedProp) this.checked = true;
		else this.checked = false;
		this.$emit('setChecked', this.checked);
	},
	template: `
	<label class="custom-checkbox">
		<input class="custom-checkbox__input" type="checkbox" :name="this.name" @change="checked = !checked" @change="$emit('setChecked', checked)" />
		<span class="custom-checkbox__block"></span>
		<span class="custom-checkbox__title" v-if="this.title">{{this.title}}</span>
		<span class="custom-checkbox__text" v-if="this.text">{{this.text}}</span>
	</label>
`,
});
